import { render, staticRenderFns } from "./ProvinceCity.vue?vue&type=template&id=2ce31f0d&scoped=true&"
import script from "./ProvinceCity.vue?vue&type=script&lang=js&"
export * from "./ProvinceCity.vue?vue&type=script&lang=js&"
import style0 from "./ProvinceCity.vue?vue&type=style&index=0&id=2ce31f0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce31f0d",
  null
  
)

export default component.exports